var _style, _defs, _clipPath, _g, _radialGradient, _path, _g2, _radialGradient2, _path2, _radialGradient3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "1 1 176 176",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".chrome_svg__B{clip-path:url(#chrome_svg__C)}.chrome_svg__C{fill:#3e2723}.chrome_svg__D{fill-opacity:.15}.chrome_svg__E{fill-opacity:.2}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "chrome_svg__A",
    cx: 96,
    cy: 96,
    r: 88
  }), /*#__PURE__*/React.createElement("path", {
    id: "chrome_svg__B",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__C"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrome_svg__A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "chrome_svg__B",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__D",
    x1: 29.34,
    x2: 81.84,
    y1: 75.02,
    y2: 44.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0,
    offset: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#chrome_svg__D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3 115.6L22.48 47.3l-.58 1 39.54 67.8z",
    className: "chrome_svg__C chrome_svg__D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrome_svg__B",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__E",
    x1: 110.9,
    x2: 52.54,
    y1: 164.5,
    y2: 130.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0,
    offset: 0.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#chrome_svg__E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8 117.3l-.83-.48-38.4 67.15h1.15l38.1-66.64z",
    fill: "#263238",
    className: "chrome_svg__D"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chrome_svg__F",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__G"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrome_svg__F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chrome_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chrome_svg__H",
    x1: 121.9,
    x2: 136.6,
    y1: 49.8,
    y2: 114.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0.3,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0,
    offset: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#chrome_svg__H)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    fill: "url(#chrome_svg__H)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chrome_svg__I",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__J"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrome_svg__I"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chrome_svg__J)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#chrome_svg__D)"
  })))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "chrome_svg__K",
    cx: 668.2,
    cy: 55.95,
    r: 84.08,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 56v20.95L174.4 56z",
    fill: "url(#chrome_svg__K)",
    className: "chrome_svg__B",
    transform: "translate(-7 -7)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "chrome_svg__B",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chrome_svg__L",
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "chrome_svg__M"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrome_svg__L"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#chrome_svg__M)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chrome_svg__B",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#chrome_svg__E)"
  })))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "chrome_svg__N",
    cx: 597.9,
    cy: 48.52,
    r: 78.04,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-7 -7)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z",
    fill: "url(#chrome_svg__N)",
    className: "chrome_svg__B"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "chrome_svg__O",
    cx: 671.8,
    cy: 96.14,
    r: 87.87,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0,
    offset: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.83 183.9l20.96-78.2 17.86 10.3z",
    fill: "url(#chrome_svg__O)",
    className: "chrome_svg__B",
    transform: "translate(-7 -7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "chrome_svg__B",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 40,
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 32,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 55c-22.1 0-40 17.9-40 40v1c0-22.1 17.9-40 40-40h88v-1H96z",
    className: "chrome_svg__C chrome_svg__E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 116c-6.92 11.94-19.8 20-34.6 20s-27.7-8.06-34.6-20h-.04L8 24.48v1L61.4 117c6.92 11.94 19.8 20 34.6 20s27.68-8.05 34.6-20h.05v-1h-.06z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.1 0 40-17.9 40-40s-17.9-40-40-40z",
    opacity: 0.1,
    className: "chrome_svg__C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 117.3c3.4-5.88 5.37-12.68 5.37-19.96a39.87 39.87 0 00-1.87-12.09c.95 3.42 1.5 7 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16L131 117.3z",
    fill: "#fff",
    className: "chrome_svg__E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 9c48.43 0 87.72 39.13 88 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z",
    fill: "#fff",
    className: "chrome_svg__E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 183c48.43 0 87.72-39.13 88-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5.27 48.37 39.56 87.5 88 87.5z",
    className: "chrome_svg__C chrome_svg__D"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgChrome as ReactComponent };